import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useApi from '../../hooks/useApi';
import './EventToAgentBind.css';

const EventToAgentBind = ({ event, agent, limit = 0, bind = true }) => {
	const { t } = useTranslation();
    const auth = useSelector(state => state.auth.user);
	const [ showForm, setShowForm ] = useState(false);
    const [ params, setParams ] = useState({ agent, event, limit });
    const [ type, setType ] = useState('undefined');
	const [ data, error, isLoading ] = useApi({ type, method: '/agent2event', params });

    const doBind = () => {
        // Изначально мы указали несуществующий тип запроса к АПИ.
        // После нажатия на компонент мы подставляем в тип нужный
        // вариант и вызываем тем самым повторный вызов АПИ.
        if(bind) {
            setType('post');
        } else {
            setType('put');
        }
    };

	// Если кликает админ, то нам не нужно показывать форму т.к. он не имеет права ставить лимит
	// Изменено по запросу в марте 2026 года, теперь админ может делать то же что и рут
	const doShowForm = () => {
		// if(auth.role === 'admin') setType('post'); else 
		setShowForm(true);
	};

	const checkLimit = (limit) => {
		if(!limit) setParams({ agent, event, limit: '' });
		else if(/^\d+$/.test(limit)) setParams({ agent, event, limit: parseInt(limit) });
	};

	// Результат запроса
	if(data) return <div className='InlineButtonBlank'>
		{data.agent2event.limit} - {t('common.noerror')}
	</div>;
	if(error) return <div className='InlineButtonBlank'>{t('common.error')}</div>;
	if(isLoading) return <div className='InlineButtonBlank'>{t('common.loading')}</div>;
	// Делать и апдейтить привязку может только рут и админ
	if(auth.role !== 'root' && auth.role !== 'admin') return null;
	// Админ может делать только новые привязки
	// Изменено по запросу в марте 2026 года, теперь админ может делать то же что и рут
	// if(auth.role === 'admin' && !bind) return <div className='InlineButtonBlank nopointer'>{limit}</div>;
	// Перед показом формы рендерим кнопку приглашения
	if(!showForm) {
		return 	<div className='InlineButtonSolid' onClick={() => doShowForm()}>
					{bind ? t('agent2event.bind_new') : <>{limit} - {t('agent2event.bind_update')}</>}
				</div>
	}
	// Форма привязки/обновления
	return <div className='EventToAgentBind'>
		<input type='text' value={params.limit} onChange={e => checkLimit(e.target.value)}/>&nbsp;
		<div className='InlineButtonSolid' onClick={() => doBind()}>
			{bind ? t('agent2event.bind_new') : t('agent2event.bind_update')}
		</div>
	</div>;
};

EventToAgentBind.propTypes = {
    event: PropTypes.string.isRequired,
    agent: PropTypes.string.isRequired,
	limit: PropTypes.number,
	bind:  PropTypes.bool, // true - новая привязка, false - апдейт старой
};

export default EventToAgentBind;
